import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import BuildingDetail from '../../components/building_detail/BuildingDetail';

import { editBuilding } from '../../redux/buildings/buildings_actions';

class BuildingEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.buildingDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isEditing !== this.props.isEditing && !nextProps.isEditing && !nextProps.errorMessage) {
      this.props.onHide();
    }
  }

  onSaveHandler() {
    const editedBuilding = this.buildingDetail.getWrappedInstance().getWrappedInstance().getBuildingData();
    const { id } = this.props.building;
    this.props.editBuilding(id, editedBuilding);
  }

  render() {
    const {
      isEditing,
      errorMessage,
      editBuilding,
      building,
      t,
      ...newProps
    } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit building')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BuildingDetail
            fieldErrors={errorMessage}
            building={building}
            ref={ref => (this.buildingDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="building-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isEditing: state.building.editing,
  errorMessage: state.building.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  editBuilding: (id, building) => dispatch(editBuilding(id, building)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BuildingEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/buildings/BuildingEditModal.js